import { useEffect, useState } from 'react'

const STORAGE_KEY = 'pauline:auth:next_resend'

/**
 * Сохраняет ISO-время ближайшего resend в sessionStorage (или очищает, если null).
 * @param isoDate - ISO-время или null для очистки
 */
export const saveNextResend = (isoDate: string | null) => {
  if (!isoDate) sessionStorage.removeItem(STORAGE_KEY)
  else sessionStorage.setItem(STORAGE_KEY, isoDate)
}

/**
 * Читает ISO-время ближайшего resend из sessionStorage.
 * @returns ISO-строка или null
 */
export const readNextResend = (): string | null => {
  return sessionStorage.getItem(STORAGE_KEY)
}

const computeLeft = (targetIso: string | null): number => {
  if (!targetIso) return 0
  const diff = new Date(targetIso).getTime() - Date.now()
  return diff <= 0 ? 0 : Math.ceil(diff / 1000)
}

/**
 * Хук-обратный отсчёт до ISO-таймстемпа. Тикает каждую секунду.
 * @param targetIso - Целевое ISO-время (или null)
 * @returns Секунд до targetIso (0 если истёк/не задан)
 */
export const useResendCountdown = (targetIso: string | null): number => {
  const [secondsLeft, setSecondsLeft] = useState(() => computeLeft(targetIso))

  useEffect(() => {
    setSecondsLeft(computeLeft(targetIso))
    if (!targetIso) return
    const id = window.setInterval(() => {
      setSecondsLeft(computeLeft(targetIso))
    }, 1000)
    return () => window.clearInterval(id)
  }, [targetIso])

  return secondsLeft
}
